import { Outlet } from "react-router";

const OutreachLayout = () => {
    return (
        <main className="outreach-layout">
            <Outlet />
        </main>
    );
};

export default OutreachLayout;
